import { Avatar } from '@/components/atoms/Avatar/Avatar/Avatar';
import AvatarGroup from '@/components/atoms/Avatar/AvatarGroup/AvatarGroup';
import { renderDialogIcon } from '@/components/organisms/SubNav/TreeView/Item';
import { cn } from '@/lib/utils';
import { Presence } from '@/shared/types/presence';

type Props = {
  dialogName: string;
  type: 'intent' | 'event' | 'unknown';
  showDot?: boolean;
  isOffTopics?: boolean;
  whoIsViewing?: Presence[];
  dotColor?: () => string;
};

const IconizedDialog = ({
  dialogName,
  type,
  showDot,
  isOffTopics,
  whoIsViewing,
  dotColor,
}: Props) => {
  return (
    <>
      {renderDialogIcon(type)}

      <span className="font-inherit block w-full overflow-hidden text-sm leading-5 font-normal text-ellipsis whitespace-nowrap">
        {dialogName}
      </span>

      {showDot && !isOffTopics && <span className={cn('text-xl leading-5', dotColor?.())}>•</span>}

      {whoIsViewing?.length ? (
        <span className="ml-3">
          <AvatarGroup max={2}>
            {whoIsViewing.map((x) => (
              <Avatar key={x.agent_id} userId={x.agent_id} size="small" />
            ))}
          </AvatarGroup>
        </span>
      ) : null}
    </>
  );
};

export default IconizedDialog;
